import React from 'react'
import { Trans } from '@lingui/react'
import styled from 'styled-components'

import FormItem from '../../util/FormItem'
import TextArea from '../../util/TextArea'

const TenantSelectionImpersonationForm = ({ formState }) => {
    const { getNativeInputProps, getErrorMessages } = formState
    return (
        <FormContainer>
            <FormItem
                label={<Trans id="Description" />}
                error={getErrorMessages('description')}
                required
            >
                <TextArea minRows={3} {...getNativeInputProps('description')} />
            </FormItem>
        </FormContainer>
    )
}

const FormContainer = styled.div`
    display: flex;
    flex-direction column;
`

export default TenantSelectionImpersonationForm
